<template>
    <div class="selectln-container" :class="{ 'pais-disabled': disabledPais }">
          <Multiselect
              aria-required="true"
              id="linea_ms"
              class="select-linea"
              label="name"
              track-by="code"
              placeholder="Seleccione"
              v-model="paisSeleccionado"
              :options="comboPaises"
              :multiple="false"
              :allow-empty="false"
              @input="validateInput()"
              :max-height="340"
              selected-label="done"
              select-label="done"
              deselect-label=""
              :searchable="false"
			  :disabled="disabledPais"
          >
              <template v-slot:noOptions>No se encontraron resultados.</template>
              <template v-slot:noResult>No se encontraron resultados.</template>
              <template slot="option" slot-scope="props">
                  <span>
                      <img style="width: 25px; margin-right: 10px;" :src="require(`@/assets/images/${props.option.icono}`)"/>
                  </span>
                  {{ props.option.name }}
              </template>
              <template slot="singleLabel" slot-scope="props">
                  <span>
					<img style="width: 25px; margin-right: 10px;" :src="require(`@/assets/images/${props.option.icono}`)"/>
                  </span>
                  {{ props.option.name }}
              </template>
          </Multiselect>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .selectln-container .select-linea,
  .selectln-container .multiselect__single {
    color: var(--text-navbar-color);
  }
  .selectln-container .multiselect__tags {
    border-right: solid 1px var(--border-navbar-color);
    border-left: solid 1px var(--border-navbar-color);
  }
  .selectln-container .multiselect__select:before {
    border-top-color: var(--border-navbar-color);
  }
  .selectln-container.pais-disabled .multiselect.multiselect--disabled,
  .selectln-container.pais-disabled .multiselect--disabled .multiselect__tags,
  .selectln-container.pais-disabled .multiselect--disabled .multiselect__select,
  .selectln-container.pais-disabled .multiselect--disabled .multiselect__single {
    background: transparent;
  }
  .selectln-container.pais-disabled .multiselect.multiselect--disabled {
    opacity: 0.5;
  }
</style>

<script>
import { mapState, mapActions } from 'vuex'
import Loading from 'vue-loading-overlay'
import Multiselect from 'vue-multiselect'

export default {
	name: 'Pais',
	components: {
		Loading,
		Multiselect
	},
	data () {
		return {
			comboPaises: [],
			paisSeleccionado: null
		}
	},
	mounted () {
		this.setPaises()
	},
	computed: {
		...mapState(['accessPaises', 'pais', 'disabledPais'])
	},
	methods: {
		...mapActions(['logout', 'doPais']),
		validateInput: function () {
			if (this.paisSeleccionado.code === '') {
				this.doPais(null)
			} else {
				this.doPais(this.paisSeleccionado)
				let path = this.$router.history.current.name
				if (this.paisSeleccionado.code === 4) {
					if (path.toLowerCase().indexOf('renting') === -1) {
						this.$router.push('/Renting/ListCotizaciones')
					}
				} else {
					if (path.toLowerCase().indexOf('resumennegocio') === -1) {
						this.$router.push('/ResumenNegocio')
					}
				}
			}
		},
		setPaises: function () {
			if (this.accessPaises.length) {
				this.accessPaises.forEach((value, key) => {
					this.comboPaises.push({ code: parseInt(value.id_pais), name: value.nombre, color: value.color, icono: value.icono, icono_color: value.icono_color, bg_navbar_color: value.bg_navbar_color, text_navbar_color: value.text_navbar_color, border_navbar_color: value.border_navbar_color, svg_logo: value.svg_logo, svg_isotipo: value.svg_isotipo, nombre_corto: value.nombre_corto })
				})
				if (this.pais !== null) {
					this.paisSeleccionado = this.pais
				} else {
					this.paisSeleccionado = this.comboPaises[0]
					this.doPais(this.paisSeleccionado)
				}
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/ui/Pais.vue